import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './auth-layout.component.html'
})
export class AuthLayoutComponent {}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/layouts/auth/auth-layout.component.ts